/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useState } from 'react';

import { SupportTypeStep } from './Steps/SupportTypeStep';
import { SupportContentStep } from './Steps/SupportContentStep';

import bugImageUrl from './assets/bug.png';
import ideaImageUrl from './assets/idea.svg';
import thoughtImageUrl from './assets/thought.svg';
import { SupportSuccessStep } from './Steps/SupportSuccessStep';

export const supportTypes = {
  BUG: {
    title: 'Problema',
    image: {
      source: bugImageUrl,
      alt: 'Imagem de um inseto',
    },
  },
  IDEA: {
    title: 'Ideia',
    image: {
      source: ideaImageUrl,
      alt: 'Imagem de uma lâmpada',
    },
  },
  OTHER: {
    title: 'Outros',
    image: {
      source: thoughtImageUrl,
      alt: 'Imagem de um balão de pensamento',
    },
  },
};

export const WidgetForm = () => {
  const [supportType, setSupportType] = useState(null);
  const [supportSent, setSupportSent] = useState(false);
  const [support, setSupport] = useState(null);

  function handleRestartSupport() {
    setSupportSent(false);
    setSupportType(null);
  }

  return (
    <div
      style={{
        width: '350px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        borderRadius: '20px',
        marginBottom: '20px',
        
        padding: '16px',
        position: 'relative',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      {supportSent ? (
        <SupportSuccessStep
          support={support}
          onSupportRestartRequested={handleRestartSupport}
        />
      ) : (
        <>
          {!supportType ? (
            <SupportTypeStep onSupportTypeChanged={setSupportType} />
          ) : (
            <SupportContentStep
              supportType={supportType}
              onSupportRestartRequested={handleRestartSupport}
              onSupportSent={(support) => {
                setSupport(support)
                setSupportSent(true);
              }}
            />
          )}
        </>
      )}

      <footer
        style={{
          fontSize: '14px',
          color: '#898887',
          textAlign: 'center',
        }}>
        support@fitinsur.com.br
      </footer>
    </div>
  );
};
